// extracted by mini-css-extract-plugin
export var navbarSubLink = "J_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "J_vv d_f0 d_dB";
export var subPageLink = "J_gf d_gf";
export var burger = "J_vV";
export var sublinkSize = "J_vW";
export var linkSize = "J_vX";
export var Link = "J_tg C_tg C_sJ C_s2";